"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SNCFIcon = SNCFIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function SNCFIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    height: "110.8",
    viewBox: "0 0 211.4 110.8",
    width: "211.4"
  }, props), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    gradientTransform: "matrix(168.9 0 0 -168.9 118.1 67.38)",
    gradientUnits: "userSpaceOnUse",
    id: "vlpa",
    x2: "1"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0",
    stopColor: "#7c2270"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: ".2472",
    stopColor: "#aa147e"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: ".8146",
    stopColor: "#e41d25"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#e41d25"
  })), /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "vlpb"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "m0 0h311.8v510.2h-311.8z"
  }))), /*#__PURE__*/_react.default.createElement("g", {
    transform: "matrix(1.25 0 0 -1.25 -147.6 77.75)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "m121.2 61.99c-1.882-0.07905-3.105-0.9486-3.105-2.808v-82.9c0-1.445 1.035-2.752 2.631-2.752h148c1.329 0 2.39 0.1205 3.015 1.875 0 0 15 46.94 15.26 47.79 0.5571 1.773 0.1957 2.673-1.317 3.636-48.2 30.89-120.3 35.37-153 35.37-4.694 0-8.571-0.0941-11.47-0.2108",
    fill: "url(#vlpa)"
  }), /*#__PURE__*/_react.default.createElement("g", {
    strokeWidth: "0.2657",
    transform: "matrix(3.764 0 0 3.764 -793.9 -171.9)"
  }, /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#vlpb)",
    strokeWidth: "0.2657"
  }, /*#__PURE__*/_react.default.createElement("g", {
    strokeWidth: "0.2657",
    transform: "translate(267.3 44.78)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "m0 0c-0.55 0.641-0.768 1.468-0.632 2.39 0.324 2.199 2.464 3.589 5.327 3.589 0.603 0 1.224-0.038 1.782-0.109l0.566 1.659c-0.69 0.106-1.526 0.151-2.346 0.151-2.539 0-4.747-0.874-6.178-2.415-0.045-0.048-0.091-0.047-0.119-0.047-0.044 0-0.074 8e-3 -0.062 0.047l0.717 2.249h-2.096l-2.294-7.197c-0.73 2.124-2.232 4.917-4.069 7.197h-2.251l-1.683-5.239c0.846-0.629 1.114-1.083 1.335-1.729 0.013-0.038 0.04-0.046 0.081-0.046s0.061 0.01 0.072 0.046c0.016 0.05 1.468 4.553 1.468 4.553 1.481-2.119 2.951-4.907 3.739-7.851h2.414l1.194 3.73c0.013 0.038 0.039 0.046 0.079 0.046 0.042 0 0.069-0.011 0.074-0.046 0.363-2.342 2.692-3.916 5.993-3.916 2.134 0 4.063 0.56 4.543 0.817l1.251 3.94h4.804l0.489 1.526h-4.805l0.829 2.587h5.725l0.499 1.582h-8.042l-2.73-8.533c-0.579-0.146-1.295-0.218-2.043-0.218-1.611 0-2.901 0.383-3.631 1.237m-13.56 5.939 0.478 1.503c-0.687 0.126-1.178 0.191-1.998 0.21-2.636 0.061-5.019-0.666-5.632-2.206-0.726-1.826 1.334-2.853 3.119-3.699 1.417-0.672 2.537-1.311 2.143-2.148-0.306-0.649-1.309-0.957-2.767-0.924-1.263 0.03-2.838 0.392-4.079 1.017l-0.738-1.596c0.913-0.424 2.795-1 4.401-1.037 3.016-0.069 4.969 0.69 5.751 2.332 0.925 1.944-1.37 3.007-3.213 3.897-1.443 0.697-2.427 1.061-2.19 1.762 0.28 0.83 1.731 1.145 3.046 1.115 0.665-0.016 1.138-0.101 1.679-0.226",
    fill: "#fff"
  }))))));
}